import React from "react";

// Presentational signup form. All business logic (state, validation,
// API call, toasts) lives in the `useSignupForm` hook so this component
// stays small, stateless, and easy to compose.
const SignupForm = ({
  form,
  submitting,
  onChange,
  onSubmit,
  ctaLabel = "Join the Free Community",
  inputVariant = "light", // "light" (on white card) | "on-dark" (on dark bg)
  className = "",
}) => {
  const inputClass =
    inputVariant === "on-dark"
      ? "ht-input w-full rounded-md bg-white/95 border border-white/40 px-4 py-3.5 text-[15px] text-[#2c3e50] placeholder:text-[#7e8a96]"
      : "ht-input w-full rounded-md border border-[#d6dde4] bg-white px-4 py-3 text-[15px] placeholder:text-[#9aa6b2]";

  return (
    <form onSubmit={onSubmit} className={`space-y-3 ${className}`}>
      <input
        name="firstName"
        value={form.firstName}
        onChange={onChange}
        placeholder="First Name"
        autoComplete="given-name"
        className={inputClass}
      />
      <input
        name="email"
        type="email"
        value={form.email}
        onChange={onChange}
        placeholder="Your Best Email"
        autoComplete="email"
        className={inputClass}
      />
      <button
        type="submit"
        disabled={submitting}
        className="ht-btn w-full rounded-md bg-[#b6dcf3] hover:bg-[#a4d1ee] text-[#2c3e50] font-semibold py-3.5 text-[15px] disabled:opacity-70"
      >
        {submitting ? "Joining..." : ctaLabel}
      </button>
    </form>
  );
};

export default SignupForm;
